import { FileText } from 'lucide-react';
import { inferAttachmentMediaKind, isPdfAttachment } from '../../utils/messageAttachments';

export type HubAttachment = {
  id?: string;
  fileName?: string;
  fileUrl: string;
  type?: string;
  mimeType?: string;
};

export function AttachmentView({ file }: { file: HubAttachment }) {
  const kind = inferAttachmentMediaKind(file);

  if (kind === 'image') {
    return (
      <a href={file.fileUrl} target="_blank" rel="noreferrer" className="block">
        <img
          src={file.fileUrl}
          alt={file.fileName || 'Attachment'}
          className="mh-bubble-attachment-img"
        />
      </a>
    );
  }

  if (kind === 'video') {
    return (
      <video
        controls
        playsInline
        preload="metadata"
        src={file.fileUrl}
        className="mh-bubble-attachment-video"
      >
        <track kind="captions" />
      </video>
    );
  }

  if (kind === 'audio') {
    return <audio controls src={file.fileUrl} className="mb-2 mt-1 w-full max-w-xs" />;
  }

  if (isPdfAttachment(file)) {
    return (
      <a href={file.fileUrl} target="_blank" rel="noreferrer" className="mh-bubble-attachment-doc">
        <FileText className="mb-1 h-8 w-8 opacity-80" aria-hidden />
        <span className="text-xs font-medium">{file.fileName || 'PDF document'}</span>
        <span className="text-[10px] opacity-80">Tap to open</span>
      </a>
    );
  }

  return (
    <a href={file.fileUrl} target="_blank" rel="noreferrer" className="mh-bubble-attachment-link">
      {file.fileName || 'Download attachment'}
    </a>
  );
}
